import React from 'react';
import { LocationConditionEnum } from '@/constants/enum';
import CityCondition from '@/pages/Settings/Components/EstimateRules/components/CURule/components/DisplayConditions/components/CityCondition';
import CountryCondition from '@/pages/Settings/Components/EstimateRules/components/CURule/components/DisplayConditions/components/CountryCondition';
import ProvinceCondition from '@/pages/Settings/Components/EstimateRules/components/CURule/components/DisplayConditions/components/ProvinceCondition';
import ZipcodeCondition from '@/pages/Settings/Components/EstimateRules/components/CURule/components/DisplayConditions/components/ZipcodeCondition';
import { IConditionValue, IItemCondition, ILocationCondition, RelationCondition } from '@/types/newSetup.type';
import { Badge } from '@shopify/polaris';

interface IProps {
  data: ILocationCondition[];
  onChange: (key: IItemCondition['type'] | ILocationCondition['type']) => (value: IConditionValue[] | null) => void;
  onRemove: (condition: IItemCondition['type'] | ILocationCondition['type']) => void;
  isInCheckout?: boolean;
  typeRelationOfItem?: RelationCondition;
}

const LocationConditionItem = ({ data, onChange, onRemove, isInCheckout, typeRelationOfItem }: IProps) => {
  return (
    <div className="main-condition-container mt-12">
      {data?.map((item, index) => {
        switch (item.type) {
          case LocationConditionEnum.Country:
            return (
              <React.Fragment key={item.type}>
                <div className="mt-16" key={item.type}>
                  <CountryCondition
                    onDismiss={() => {
                      onRemove(item.type);
                    }}
                    data={data?.find((item) => item.type === LocationConditionEnum.Country)?.value || []}
                    handleChange={(value) => {
                      onChange(item.type)(value);
                    }}
                    isInCheckout={isInCheckout}
                  />
                </div>
                {typeRelationOfItem && data?.length > 1 && index !== data.length - 1 && (
                  <div className="mt-16">
                    <Badge tone="info">{typeRelationOfItem.toLocaleUpperCase()}</Badge>
                  </div>
                )}
              </React.Fragment>
            );
          case LocationConditionEnum.Zipcode:
            return (
              <React.Fragment key={item.type}>
                <div className="mt-16" key={item.type}>
                  <ZipcodeCondition
                    onDismiss={() => {
                      onRemove(item.type);
                    }}
                    isInCheckout={isInCheckout}
                  />
                </div>
                {typeRelationOfItem && data?.length > 1 && index !== data.length - 1 && (
                  <div className="mt-16">
                    <Badge tone="info">{typeRelationOfItem.toLocaleUpperCase()}</Badge>
                  </div>
                )}
              </React.Fragment>
            );
          case LocationConditionEnum.State:
            return (
              <div className="mt-16" key={item.type}>
                <ProvinceCondition
                  onDismiss={() => {
                    onRemove(item.type);
                  }}
                  isInCheckout={isInCheckout}
                />
              </div>
            );
          case LocationConditionEnum.City:
            return (
              <React.Fragment key={item.type}>
                <div className="mt-16" key={item.type}>
                  <CityCondition
                    onDismiss={() => {
                      onRemove(item.type);
                    }}
                    isInCheckout={isInCheckout}
                  />
                </div>
                {typeRelationOfItem && data?.length > 1 && index !== data.length - 1 && (
                  <div className="mt-16">
                    <Badge tone="info">{typeRelationOfItem.toLocaleUpperCase()}</Badge>
                  </div>
                )}
              </React.Fragment>
            );
          default:
            return null;
        }
      })}
    </div>
  );
};

export default LocationConditionItem;
